import type { RouteRecordRaw } from 'vue-router';

import { MainPage } from '@/pages/main';
import { HotOffersPage } from '@/pages/hot-offers';
import { FavoritesPage } from '@/pages/favorites';
import { FavoritesDirectionPage } from '@/pages/favorites-direction';
import SearchPage from '@/pages/search/SearchPage.vue';
import ResultsPage from '@/pages/results/ResultsPage.vue';
import OfferDetailsPage from '@/pages/offer-details/OfferDetailsPage.vue';
import SpecialOffersPage from '@/pages/special-offers/SpecialOffersPage.vue';
import SpecialOfferDetailsPage from '@/pages/special-offer-details/SpecialOfferDetailsPage.vue';
import { FareFamilyPage, PassengersDataPage } from '@/pages/booking/details';
import {
  ProductsPage,
  AncillaryBaggagePage,
  SeatMapPage,
} from '@/pages/booking/products';
import { QuickBookingPage } from '@/pages/booking/quick-booking';
import PaymentPage from '@/pages/payment/PaymentPage.vue';
import { SurchargePage } from '@/pages/surcharge';
import { QuizPage } from '@/pages/quiz';

import { getDecodedBase64Deeplink } from '@/entities/base-64-deeplinks';

export const routes: RouteRecordRaw[] = [
  {
    path: '/:source?',
    name: 'MainPage',
    component: MainPage,
    props: true,
  },
  {
    path: '/favorites',
    name: 'FavoritesPage',
    component: FavoritesPage,
  },
  {
    path: '/favorites/direction/:routeKey',
    name: 'FavoritesDirectionPage',
    component: FavoritesDirectionPage,
    props: true,
  },
  {
    path: '/hot-offers/:origCity/:destCountry/:source?',
    name: 'HotOffers',
    component: HotOffersPage,
    props: true,
  },
  {
    path: '/search/:hashCode/:source?',
    name: 'SearchPage',
    component: SearchPage,
    props: true,
    children: [
      {
        path: '',
        name: 'OffersResults',
        component: ResultsPage,
        props: true,
      },
      {
        path: 'details/:offerId',
        name: 'OfferDetails',
        component: OfferDetailsPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/fare-family/:source?',
        name: 'FareFamilyPage',
        component: FareFamilyPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/quick-booking/:source?',
        name: 'QuickBookingPage',
        component: QuickBookingPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/passengers/:source?',
        name: 'PassengersDataPage',
        component: PassengersDataPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/products/:source?',
        name: 'ProductsPage',
        component: ProductsPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/baggage',
        name: 'AncillaryBaggagePage',
        component: AncillaryBaggagePage,
      },
      {
        path: 'booking/:resultId/:offerId/seat-map',
        name: 'SeatMapPage',
        component: SeatMapPage,
        props: true,
      },
    ],
  },
  {
    path: '/surcharge/:billId',
    name: 'SurchargePage',
    component: SurchargePage,
    props: true,
  },
  {
    path: '/payment/:orderId/:fromCabinet?',
    name: 'PaymentPage',
    component: PaymentPage,
    props: true,
  },
  {
    path: '/special-offers',
    name: 'SpecialOffersPage',
    component: SpecialOffersPage,
    props: true,
  },
  {
    path: '/special-offers/:offerId',
    name: 'SpecialOfferDetails',
    component: SpecialOfferDetailsPage,
    props: true,
  },
  {
    path: '/search/:hashCode/deep_link/details/:offerHash',
    redirect: to => ({
      name: 'OffersResults',
      params: { hashCode: to.params.hashCode, source: 'deep_link' },
      query: { offerHash: to.params.offerHash },
    }),
  },
  {
    path: '/search/:hashCode/sapp_button/details/:offerHash',
    redirect: to => ({
      name: 'OffersResults',
      params: { hashCode: to.params.hashCode, source: 'sapp_button' },
      query: { offerHash: to.params.offerHash },
    }),
  },
  {
    path: '/deeplink/base64/:encodedString',
    name: 'Base64Deeplink',
    redirect: to => {
      return getDecodedBase64Deeplink(to.params.encodedString as string);
    },
  },
];
